export default {
  methods: {
    numberFormat(value, key) {
      if (isNaN(value)) {
        return value;
      }
      if (typeof value === 'string') {
        return value;
      }
      if (Number.isInteger(value) && key === 'id') {
        return value;
      }
      value = parseFloat(value).toFixed(2);

      return value.replace(/\d(?=(\d{3})+\.)/g, '$&,');
    },
  },
};



// WEBPACK FOOTER //
// ./src/app/mixins/numberFormat.js